export const ServiceHelper = {
  Status: {
    Active: "active",
    Inactive: "inactive",
  },
};
